import { Injectable } from "@angular/core"

//DO NOT DELETE if empty: will be used for feature flags in next implementations
@Injectable({ providedIn: "root" })
export class FeatureFlagsService {
    get searchRedesignFeatureFlag(): boolean {
        return window["PBSLM"]?.FEATURE_FLAGS?.SEARCH_REDESIGN ?? false
    }

    get redesignSearchAutocompleteFeatureFlag(): boolean {
        return window["PBSLM"]?.FEATURE_FLAGS?.REDESIGN_SEARCH_AUTOCOMPLETE ?? false
    }
}
